









































import Enumerable from "linq";
import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import { WorkflowCommonMixin } from "../../../mixins";
import { Comparator } from "../../../../../domain/system";
import { ReceptionComment } from "../../../../../domain/workflow/reception";
import { ReceptionCommentUnitKinds, ReceptionCommentKinds, ReceptionCommentKindsName, ReceptionCommentSortItemKinds } from "../../../../../domain/workflow/kinds";

import CommentNarrowTable from "./CommentNarrowTable.vue";
import CommentWideTable from "./CommentWideTable.vue";

import { ModelEditableMixin } from "../../../../../components/system/mixins";

@Component({
  components: {
    CommentNarrowTable,
    CommentWideTable,
  }
})
export default class CommentTable extends Mixins(WorkflowCommonMixin, ModelEditableMixin) {
  @Prop()
  mode: ReceptionCommentUnitKinds;

  @Prop()
  title: string;

  @Prop()
  value: ReceptionComment;

  @Prop()
  isWide: boolean;

  @Prop()
  comments: ReceptionComment[];

  @Prop({ default: true })
  hasPermission: boolean;

  @Prop()
  detailSelected: boolean;

  @Prop()
  sortType: ReceptionCommentSortItemKinds;

  @Prop({ default: true })
  isCommentEditable: boolean;

  @Prop({ default: true })
  isCommentDeletable: boolean;

  @Prop({ default: false })
  isReadOnly: boolean;

  @Prop({ default: false })
  shouldSortCommentAsc: boolean;

  @Emit()
  add(): void {}

  @Emit()
  edit(row: ReceptionComment): void {}

  @Emit()
  remove(row: ReceptionComment): void {}

  mounted() {
    this.sortComments(this.editingSource);
  }

  data(): any {
    return {
      sortTypeCreateDateTime: ReceptionCommentSortItemKinds.CreateDateTime,
      sortTypeUpdateDateTime: ReceptionCommentSortItemKinds.UpdateDateTime,
    };
  }
  sortTypeCreateDateTime: ReceptionCommentSortItemKinds;
  sortTypeUpdateDateTime: ReceptionCommentSortItemKinds;

  // セクション部分に追加ボタンを表示するか
  get addButtonVisible(): boolean {
    return this.detailSelected && this.hasPermission 
      && (this.mode === ReceptionCommentUnitKinds.Single && this.exceptConflictCommentCount() === 0 || this.mode === ReceptionCommentUnitKinds.Multiple)
      && !this.isReadOnly; 
  }

  // セクション部分に編集ボタンを表示するか
  get editButtonVisible(): boolean {
    return this.detailSelected && this.mode === ReceptionCommentUnitKinds.Single && this.exceptConflictCommentCount() > 0
      && this.exceptConflictComment[0].isEditable // 詳細が選択済み　コメント単位が単数　コメントが登録済み　編集可の場合
      && !this.isReadOnly;
  }

  get isMultipleMode(): boolean {
    return this.mode === ReceptionCommentUnitKinds.Multiple;
  }

  get isEditable(): boolean {
    return this.isCommentEditable && !this.isReadOnly;
  }

  get isDeletable(): boolean {
    return this.isCommentDeletable && !this.isReadOnly;
  }

  // 競合コメントを除いたコメント数
  private exceptConflictCommentCount(): number {
    return this.exceptConflictComment.length;
  }

  // 競合コメントを除いたコメント
  private get exceptConflictComment(): ReceptionComment[] {
    return Enumerable.from(this.comments).where(m => m.type !== ReceptionCommentKindsName.getTypeName(ReceptionCommentKinds.Conflict)).toArray();
  }

  private sortComments(sortType: ReceptionCommentSortItemKinds): void {
    this.comments.sort((a, b) => {
      return this.getCompare(sortType)(a, b);
    });
  }

  private getCompare(sortType: ReceptionCommentSortItemKinds): (a: ReceptionComment, b: ReceptionComment) => number {
    switch (sortType) {
      case ReceptionCommentSortItemKinds.UpdateDateTime:
        return this.getCompareUpdateDateTime();
      case ReceptionCommentSortItemKinds.CreateDateTime:
        return this.getCompareCreateDateTime();
      default:
        return this.getCompareUpdateDateTime();
    }
  }

  private compare(a: any, b: any): number {
    return Comparator.compare(a, b, this.shouldSortCommentAsc);
  }

  private getCompareUpdateDateTime(): (a: ReceptionComment, b: ReceptionComment) => number {
    return (a, b) => this.compare(a.updateDateTime, b.updateDateTime);
  }

  private getCompareCreateDateTime(): (a: ReceptionComment, b: ReceptionComment) => number {
    return (a, b) => this.compare(a.createDateTime, b.createDateTime);
  }

  @Watch("editingSource")
  onSelectedSortTypeChanged(newValue: ReceptionCommentSortItemKinds) {
    if (this.comments && this.comments.length > 0) {
      this.sortComments(newValue);
    }
  }

  @Watch("comments")
  onCommentsUpdated(newValue: ReceptionComment[], oldValue: ReceptionComment[]) {
    if (this.isMultipleMode && newValue && newValue.length > 0 && newValue !== oldValue) {
      this.sortComments(this.editingSource);
    }
  }
}
